export enum DraftJobChangeField {
  // job-level
  PACKAGES = 'PACKAGES',
  SLA = 'SLA',
  TAGS = 'TAGS',
  SKILLS = 'SKILLS',
  PACKED = 'PACKED',
  ACCOUNT_ID = 'ACCOUNT_ID',
  PRICE_PLAN_PROGRAM_TYPE = 'PRICE_PLAN_PROGRAM_TYPE',
  // stop-level
  NOT_BEFORE = 'NOT_BEFORE',
  NOT_AFTER = 'NOT_AFTER',
  DETAILED_SERVICE_TIME = 'DETAILED_SERVICE_TIME',
  ADDRESS = 'ADDRESS'
}
